import { Mine } from "../pages/HomePage";
import { url } from "./auth"

export const getMines = async (): Promise<Mine[] | null> => {    
    try {
        const urlMines = url + "api/get";
        const response = await fetch(urlMines, {
            method: 'GET',
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();

        if (!Array.isArray(data)) {
            console.log('Invalid data format:', data);
            return null;
        }

        const mines: Mine[] = [];
        for (const mine of data) {
            const newMine: Mine = {
                id: mine.id,
                title: mine.title,
                element_type: mine.element_type,
                content: mine.content,
                position: [mine.position.lat, mine.position.lng],
                images: mine.images ? mine.images.map((image: any) => ({
                    id: image.id,
                    src: image.src,
                    comment: image.comment
                })) : [],
                links: mine.links ? mine.links.map((link: any) => ({
                    id: link.id,
                    title: link.title,
                    url: link.url
                })) : []
            };
            mines.push(newMine);
        }
        return mines;

    } catch (error) {
        console.log('Get error:', error);
        return null;
    }
}

export const addMine = async (mine: Mine, token: string): Promise<Mine | null> => {
    try {
        const urlMines = url + "api/add";
        const response = await fetch(urlMines, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(mine)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.log('Add error:', error);
        throw error;
    }
}

export const updateMine = async (mine: Mine, token: string): Promise<Mine | null> => {
    try {
        const urlMines = url + "api/update";
        const response = await fetch(urlMines, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(mine)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.log('Update error:', error);
        throw error;
    }
}

export const deleteMine = async (mineId: string, token: string): Promise<void> => {
    try {
        const urlMines = url + "api/delete/" + mineId;
        const response = await fetch(urlMines, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

    } catch (error) {
        console.log('Delete error:', error);
        throw error;
    }
}
